import { useDispatch, useSelector } from 'react-redux';
import { changeNumberOfUsers } from 'software_products/redux/slice';
import { selectDataForCart } from 'software_products/redux/selectors';
import { doAddToCart } from 'shared/thunks';
import { checkCartItems } from 'software_renewal/redux/thunks';

const useSoftwareProductCart = () => {
  const dispatch = useDispatch();
  const cartData = useSelector(selectDataForCart);

  const onAddToCart = async () => {
    const form = new FormData();
    form.append('variant_id', cartData.selectedVariant.id);
    form.append('quantity', 1);

    try {
      const cart = await dispatch(checkCartItems()).unwrap();
      await dispatch(doAddToCart(form)).unwrap();

      const { line_items, user_signed_in } = cart;
      if (line_items.length === 0 && user_signed_in) {
        // eslint-disable-next-line
        window.location.href = '/checkout';
      } else {
        // eslint-disable-next-line
        window.location.href = '/cart';
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };

  const onQuantityChange = (e) => {
    dispatch(changeNumberOfUsers(e.target.value));
  };

  return { ...cartData, onAddToCart, onQuantityChange };
};

export default useSoftwareProductCart;
